import {
  JarvisAuthProvider,
  JarvisWebHttpClient,
  JarvisWebHttpClientRequestOptions
} from '@jarvis/web-http'
import { Logger } from '../../utils/helperMethods'
import { PLSData } from '../../interface/controllerInterface'

export class PLSClient {
  jarvisWebHttpInstance: JarvisWebHttpClient

  constructor(baseURL: string, authProvider: JarvisAuthProvider) {
    this.jarvisWebHttpInstance = new JarvisWebHttpClient({
      defaultBaseURL: baseURL,
      defaultAuthProvider: authProvider
    })
  }

  /**
   * Create new session on onboarding-director API
   *
   * @param sessionPayload request body
   * @returns Axios response object
   */
  async getPrinterData(printerModel: string): Promise<PLSData> {
    Logger.debug(`Retrieving printer data for model: ${printerModel}`)
    const options: JarvisWebHttpClientRequestOptions = {
      url: `api/2/helper_nonAuth/printer-detail/${printerModel}`
    }
    const { data } = await this.jarvisWebHttpInstance.get(options)
    return data as PLSData
  }
}
